
import { EMPTY_PARTICIPATION_RATE_ENTITY, ParticipationRateEntity } from "domain/entity/ParticipationRate/ParticipationRateEntity";
import { EMPTY_PARTICIPATION_RATE_SEARCH_CRITERIA, ParticipationRateSearchCriteria } from "domain/entity/ParticipationRate/ParticipationRateSearchCriteria";
import { BaseViewChangeSate } from "../BaseViewChangeState";
import { DropdownProps } from "../DropdownProps";

export interface ParticipationRateDropdownOptions {
    consortiumCodeDropdownOptions: DropdownProps[],
    cntrStatusDropdownOptions: DropdownProps[],
}
export interface MasterChangeState extends BaseViewChangeSate {
}

export interface ParticipationRateMaintenanceModel {
    isLoading: boolean,
    tableData: ParticipationRateEntity[],
    currentSelectedRow: ParticipationRateEntity,
    selectedRows: ParticipationRateEntity[],
    dynamicOptions: ParticipationRateDropdownOptions,
    masterState: MasterChangeState,
    isBackMaster: boolean,
    isShowEditPanel: boolean,
    forceRefresh: boolean,
    isEdit: boolean,
    isRead: boolean,
    isShowSearchPanel: boolean,
    isShowSearchClick: boolean,
    editingEntity: ParticipationRateEntity,
    searchCriteria: ParticipationRateSearchCriteria,
}

export const EMPTY_MASTER_PARTICIPATION_RATEANY_MODEL: ParticipationRateMaintenanceModel = {
    isLoading: false,
    tableData: [],
    currentSelectedRow: { ...EMPTY_PARTICIPATION_RATE_ENTITY },
    selectedRows: [],
    dynamicOptions: {
        consortiumCodeDropdownOptions: [],
        cntrStatusDropdownOptions: []
    },
    masterState: {
        isSliderOpen: false,
        isTabularDataActive: false,
        isAdd: false,
        isRead: false,
        isEditable: false,
        isSaveClicked: false,
        lastEditRowId: "",
        isSelected: false,
        slider: {
            isAdd: false,
            isRead: false,
            isEditable: false
        },
    },
    editingEntity: { ...EMPTY_PARTICIPATION_RATE_ENTITY },
    isBackMaster: false,
    isShowEditPanel: false,
    forceRefresh: false,
    isEdit: true,
    isRead: false,
    searchCriteria: { ...EMPTY_PARTICIPATION_RATE_SEARCH_CRITERIA },
    isShowSearchPanel: false,
    isShowSearchClick: false
}